import { useMutation } from '@tanstack/react-query';

import { accountUserDetailKey } from '../../common/queryKeys';
import AppApi from '../../../../../../lib/api/app/AppApi';
import { setRequestForm } from '../../../../../../lib/common';

export const useGenerateCouponMutate = ({ options }) => {
  return useMutation(
    [...accountUserDetailKey, 'couponDetail', 'generate', 'coupon'],
    async (payload) => {
      const result = await AppApi.generateCoupon(setRequestForm(payload, true));
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
    },
  );
};
